import React, {FC} from 'react';

import {
  TopicReferencePreviewerUnfurl,
  TopicReferencePreviewerUnfurlBaseProps,
  TopicReferencePreviewerUnfurlTypesEnum,
} from './topicReferencePreviewerUnfurl';

/*
 * Props.
 */

interface AnnotationTopicReferencePreviewerUnfurlProps extends TopicReferencePreviewerUnfurlBaseProps {
  isRenderingUrl: boolean;
  isRenderingComment: boolean;
}

/*
 * Component.
 */

export const AnnotationTopicReferencePreviewerUnfurl: FC<AnnotationTopicReferencePreviewerUnfurlProps> = (
  props,
) => (
  <TopicReferencePreviewerUnfurl
    application={props.application}
    topic={props.topic}
    className={props.className}
    customFieldDataArray={props.customFieldDataArray}
    isAboveComment={props.isRenderingComment}
    isUnderUrl={props.isRenderingUrl}
    type={TopicReferencePreviewerUnfurlTypesEnum.MESSAGE}
    timeFormat={props.timeFormat}
    dateTimeFormat={props.dateTimeFormat}
  />
);
